import { Routes } from '@angular/router';
import { ConfigurationDashboardComponent } from './components/configuration-dashboard.component';

export const routes: Routes = [
  {
    path: 'configuration',
    component: ConfigurationDashboardComponent,
    data: {
      title: 'Configuration',
      isNav:  true,
      icon: 'tune',
      permissions: ['RuleModule.BusinessRule:View', 'VocabularyModule.CodeSystem:View']
    },
    children: []
  }
];



// WEBPACK FOOTER //
// ./src/app/configuration/routes.config.ts